import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { IPreferencePhoto } from './photo.types';

@Timestampable
@Untrackable
export class PreferencePhoto extends AbstractDocument<IPreferencePhoto> {
  readonly collections = {};
}
